import React, { useState, useEffect } from   'react';
import {NavLink, useNavigate, useParams } from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';
import CargandoSpinner from '../Utils/CargandoSpinner';
import { useForm } from 'react-hook-form';
import { Card, Button, Form, Row, Col, FormGroup } from 'react-bootstrap';
import moment from 'moment';
import MenuHogarSSV from './MenuHogarSSV';

export default function SSVReunificacion() {
    const { token } = useAuth();
    const { idEncuesta } = useParams();
    const [Cargando, setCargando] = useState(false);
    const [nombreJefe, setNombreJefe] = useState('');
    const [swalProps, setSwalProps] = useState({});
    const defaultValues = {
        id: 0,
        idenc_idficha: '',
    };
    const { watch, handleSubmit, register, setValue, getValues, reset, trigger, control, formState: { errors }} = useForm({ 
            defaultValues: defaultValues
        }
    );
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const fetchData = async (idEncuesta) => {
        let url = `/encuestassv/hogar/crearformularioreunificacion`;
        let obj = { idEncuesta: idEncuesta };
        await apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;

            resetForm(result.reunificacion);
            setNombreJefe(result.jefeHogar.nombre || '');

            console.log('Datos de reunificación obtenidos:', result);
        })
        .catch(error => {
            if (error.response.data.message) {
                Mensaje('Error', error.response.data.message);
            } else {
                Mensaje('Error', 'No se pudieron obtener los datos de reunificación de la persona.');
            }
        })
        .finally(() => {
            setCargando(false);
        });
    };
    
    useEffect(() => {
        fetchData( idEncuesta);
    }, [idEncuesta]);    

    async function GuardarDatosReunificacion() {
        const valid = await trigger(); 
        if (!valid) {
            setSwalProps({
                show: true,
                title: 'Validar formulario',
                text: 'Por favor complete el formulario correctamente antes de guardar.',
                icon: 'warning',
            });
            return;
        }
        const datosFormulario = getValues();
        let url = `/encuestassv/hogar/guardardatosreunificacion`;
        datosFormulario.vivienda_cuanto_pago_ultima_vez = datosFormulario.vivienda_cuanto_pago_ultima_vez ? moment(datosFormulario.vivienda_cuanto_pago_ultima_vez).format('YYYY-MM-DD') : null;
        setCargando(true);
        await apiService.post(url, datosFormulario, token)
        .then(response => {
            const result = response.data;
            if (response.status === 200) {
                Mensaje('Guardar', result.message + ' Id: ' + result.id);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos de reunificación de la persona.');
            }
        })
        .catch(error => {
            if (error?.response?.data?.message) {
                Mensaje('Error', error.response.data.message);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos de reunificación de la persona. ' + (error.message || ''));
            }
        })
        .finally(() => {
            setCargando(false);
        });
    }

    const resetForm = (data) => {
        try {
            if (data) {
                if (data.vivienda_cuanto_pago_ultima_vez == '1901-01-01') {
                    data.vivienda_cuanto_pago_ultima_vez = '';
                }
                reset((prevValues) => ({
                    ...prevValues,
                    id: data.id || '',
                    fichaid: data.fichaid || '',
                    reunificacion_miembro_hogar_se_separaro: data.reunificacion_miembro_hogar_se_separaro || '',
                    reunificacion_familiar_contacto_o_vivir_juntos: data.reunificacion_familiar_contacto_o_vivir_juntos || '',
                    reunificacion_familiar_apoyo_gobierno: data.reunificacion_familiar_apoyo_gobierno || '',
                    reunificacion_familiar_la_recibio: data.reunificacion_familiar_la_recibio || '',
                    reunificacion_familiar_porque_no_solicito_apoyo: data.reunificacion_familiar_porque_no_solicito_apoyo || '',
                    reunificacion_familiar_4_a_cual: data.reunificacion_familiar_4_a_cual || '',
                    reunificacion_familiar_observaciones: data.reunificacion_familiar_observaciones || '',
                }))
            }
        } catch (error) {
            console.error('Error al resetear el formulario:', error);
        }
    }
    
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">SSV Reunificaci&oacute;n Familiar</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item"><NavLink to={`/encuestassv/id/${idEncuesta}`} > Ficha</NavLink></li>
                        <li className="breadcrumb-item active"> Reunificaci&oacute;n Familiar</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </div>
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">                
                <div className="container-fluid">
                    <Form onSubmit={handleSubmit(GuardarDatosReunificacion)}>
                        <Card>
                            <Card.Header>
                                <h3 className="box-title"><b>J.REUNIFICACI&Oacute;N FAMILIAR - {getValues("id")}</b></h3>
                                <p>(para el[la] jefe[a] del hogar o su conyugue). - {nombreJefe}</p>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>1. Cuándo el hogar se desplazó, ¿algún miembro del hogar se vio obligado a separarse?</Form.Label>
                                    <Form.Control as="select" id="reunificacion_miembro_hogar_se_separaro" style={{width: "100%"}}  {...register('reunificacion_miembro_hogar_se_separaro')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No (Terminar encuesta)</option>
                                    </Form.Control>
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>2. ¿Han vuelto a tener contacto o a vivir juntos después de la separacion causada por el desplazamiento?</Form.Label>
                                    <Form.Control as="select" id="reunificacion_familiar_contacto_o_vivir_juntos" style={{width: "100%"}}  {...register('reunificacion_familiar_contacto_o_vivir_juntos')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si (Terminar encuesta)</option>
                                        <option value='2'>2. No</option>
                                    </Form.Control>
                                    </FormGroup>   
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>3. ¿El hogar solicitó apoyo del gobierno u otra entidad privada para la reunificación familiar?</Form.Label>
                                    <Form.Control as="select" id="reunificacion_familiar_apoyo_gobierno" style={{width: "100%"}}  {...register('reunificacion_familiar_apoyo_gobierno')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                    </Form.Control>
                                    </FormGroup>  
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>3.a. ¿La recibio?</Form.Label>
                                    <Form.Control as="select" id="reunificacion_familiar_la_recibio" style={{width: "100%"}}  {...register('reunificacion_familiar_la_recibio')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si (Terminar encuesta)</option>
                                        <option value='2'>2. No</option>
                                    </Form.Control>
                                    </FormGroup>   
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>4. ¿Por qué no solicitó apoyo para la reunificación familiar?</Form.Label>
                                    <Form.Control as="select" id="reunificacion_familiar_porque_no_solicito_apoyo" style={{width: "100%"}}  {...register('reunificacion_familiar_porque_no_solicito_apoyo')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. No le interesa</option>
                                        <option value='2'>2. No conoce el proceso de reunificación</option>
                                        <option value='3'>3. Otra, Cuál?</option>
                                    </Form.Control>
                                    <Form.Control id="reunificacion_familiar_4_a_cual" type="text" placeholder="Cual?" {...register('reunificacion_familiar_4_a_cual')} />
                                    </FormGroup>  
                                </Col>
                                </Row>
                                <Row>
                                <Col md={12}>
                                    <FormGroup>
                                    <Form.Label>Observaciones</Form.Label>
                                    <Form.Control as="textarea" id="reunificacion_familiar_observaciones" rows="3" placeholder="Observaciones" {...register('reunificacion_familiar_observaciones')} />
                                    </FormGroup>  
                                </Col>
                                </Row>
                            </Card.Body>
                            <Card.Footer>
                                <Row>
                                    <Col md={12}>
                                        <Button type="submit" className="btn btn-block btn-primary btn-sm" id="btnupdateAlimentos2">Actualizar</Button>  
                                    </Col>
                                </Row>
                            </Card.Footer>
                        </Card>
                    </Form>
                    <MenuHogarSSV idEncuesta={idEncuesta} />
                </div>
                <SweetAlert2 {...swalProps} 
                    didClose={() => {
                        setSwalProps({})
                    }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
            
        </div>
      
  )
  }